import { PrimaryShipment } from "../../../types/models/Shipment";
import ShipmentName from "./ShipmentName";
import { shipmentApi } from "../../../apis/Shipment.api.ts";
import {linkPath as linkPathParent} from "../../../../timber/components/timberStorage/TimberStorageDetail/TimberStorageLink";    
import * as React from 'react';
import { NavLink } from "react-router";
import Link, { LinkProps } from '@mui/material/Link';
import {useDispatch} from "react-redux";
import {ID} from "../../../../types/global";
import {ReactElement} from "react";

interface LinkRouterProps extends LinkProps {
    to: string;
    replace?: boolean;
}

type IFormProps = {
    icon?: ReactElement,
    id: ID;

};

function LinkRouter(props: LinkRouterProps) {
    return <Link {...props} component={NavLink as any} />;
}

export const linkPath = async (dispatch, id) => {
    const {data} = await dispatch(shipmentApi.endpoints.getShipment.initiate(PrimaryShipment.fromId(id)))
    if (!data) return null;
    const prefix = await linkPathParent(dispatch, data.storageId)
    return `${prefix}/shipments/${PrimaryShipment.fromId(id).toPath()}`
}

const ShipmentLink: React.FC<IFormProps> = ({id, icon}) => {
    
    const dispatch = useDispatch()
    const [link, setLink] = React.useState('')
    
    React.useEffect(() => {
        linkPath(dispatch, id)
            .then(setLink)
    }, [id])

    if (id)
        if (link)
            return (
                <LinkRouter to={ `/dashboard${link}` } viewTransition={true}>
                    <ShipmentName id={id}/> { icon && icon }
                </LinkRouter>
            )
        else
            return (<ShipmentName id={id}/>)
    else
        return undefined
}
export default ShipmentLink;
